import React from 'react'
import { motion } from 'framer-motion'
import { CalendarPlus, Upload, Link2 } from 'lucide-react'

const SubmitEventPage = () => {
  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-20">
        <div className="container-max max-w-3xl mx-auto">
          <motion.div className="text-center mb-8" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-4xl font-display font-bold text-white mb-3">Submit
              <span className="text-gradient block">Your Event</span>
            </h1>
            <p className="text-white/70">Free listings for Wichita music events. Moderation within 24 hours.</p>
          </motion.div>

          <motion.form className="glass-card p-8 space-y-4" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }} onSubmit={(e) => e.preventDefault()}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-white/80 mb-2">Event Title</label>
                <input className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="e.g., Jazz Night at The Wave" />
              </div>
              <div>
                <label className="block text-white/80 mb-2">Artist/Host</label>
                <input className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="Artist or Venue" />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-white/80 mb-2">Date & Time</label>
                <input type="datetime-local" className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-le-accent" />
              </div>
              <div>
                <label className="block text-white/80 mb-2">Price</label>
                <input className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="Free or $25" />
              </div>
            </div>
            <div>
              <label className="block text-white/80 mb-2">Venue Address</label>
              <input className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="Street, City" />
            </div>
            <div>
              <label className="block text-white/80 mb-2">Description</label>
              <textarea rows={5} className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="Event details" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-white/80 mb-2">Event Link</label>
                <div className="relative">
                  <Link2 className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" size={18} />
                  <input className="w-full bg-white/10 border border-white/20 rounded-xl pl-10 pr-3 py-3 text-white placeholder-white/40 focus:outline-none focus:border-le-accent" placeholder="https://" />
                </div>
              </div>
              <div>
                <label className="block text-white/80 mb-2">Cover Image</label>
                <button className="w-full btn-secondary flex items-center justify-center space-x-2"><Upload size={18} /><span>Upload</span></button>
              </div>
            </div>
            <button className="btn-primary w-full flex items-center justify-center space-x-2"><CalendarPlus size={18} /><span>Submit Event</span></button>
          </motion.form>
        </div>
      </section>
    </div>
  )
}

export default SubmitEventPage

